import React from 'react'

import {AddUser_Manager} from "../../model/manager"
import UserToAdd from "../../model/add-user"
import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import FieldFormElementView from "../../../../fields3/render/form-elemnent-view"
import {FIELDS} from "../../../../fields3/fields.const"
import {MeetingRole} from "../../../../model2/meeting/const"

const meetingRoleField = new FieldDropdown({
    fieldId         : 'meetingRole',
    type            : FIELDS.DROPDOWN,
    noValueOption   : false,
    showMenuMore    : false,
    options         : [
        {
            value   : MeetingRole.PARTICIPANT,
            label   : 'Participant',
        },
        {
            value   : MeetingRole.ORGANIZER,
            label   : 'Organizer',
        },
    ],
})

type Props = {
    manager     : AddUser_Manager
    userToAdd   : UserToAdd
}

export default function ModalAddUser_MeetingRoleCell(props: Props) {

    const onChange = (role: MeetingRole) => {
        props.userToAdd.meetingRole = role
        props.manager.reRender()
    }

    return (
        <div className="cell w-160">
            {props.userToAdd.isSelected &&
                <FieldFormElementView
                    className   = "w-140"
                    field       = {meetingRoleField}
                    options     = {{size: '30'}}
                    model       = {props.userToAdd}
                    onChange    = {onChange}
                />
            }
        </div>
    )
}
